<template>
  <tr>
    <td>
      <el-popover v-if="! editMode"
        placement="top"
        trigger="hover"
        :width="50"
      >
        <div style="margin: 0">
          <button class="btn btn-primary btn-outline btn-sm" style="margin-left: 8px;"
            @click="addInstances"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <router-link :to="`/products/${product.id}`" slot="reference">
          {{ product.name }}
        </router-link>
      </el-popover>
      <input v-else class="form-control" v-model="productToEdit.name">
    </td>
    <td>
      <template v-if="! editMode">
        <a href="#"
          v-for="(productCategory, index) in product.product_categories" :key="productCategory.id"
          @click.prevent="$emit('filterProductCategory', productCategory)"
        >
          {{ productCategory.name }}<span v-if="index !== product.product_categories.length - 1">, </span>
        </a>
      </template>
      <multiselect v-model="productToEdit.product_category"
        :options="productCategories"
        track-by="id"
        label="name"
        v-if="editMode"
        selectLabel=""
        deselectLabel=""
      />
    </td>
    <td>
      <router-link :to="`/suppliers/${cheapestSupplier.supplier.id}`"
        v-if="cheapestSupplier"
      >
        {{ cheapestSupplier.supplier.name }}
      </router-link>
      <div v-else class="text-center nowrap">
        <button class="btn btn-link btn-xs btn-primary"
          @click="openAssignToSuppliersDialog"
        >
          <i class="fas fa-plus"></i><i class="fas fa-truck"></i>
        </button>
      </div>
    </td>
    <td class="text-right">
      <span v-if="! editMode || cheapestSupplier">{{ cheapestPrice | priceFromCentEuro }}</span>
      <price-input :price="productToEdit.standard_price" class="quick-input"
        v-else
        @input="productToEdit.standard_price = $event"
      />
    </td>
    <td class="text-right">
      <span v-if="! editMode">{{ product.price | priceFromCentEuro }}</span>
      <input class="form-control quick-input" v-else :value="price" @input="price = $event.target.value">
    </td>
    <td class="text-right">{{ product.quantity }}</td>
    <td class="text-right">{{ product.quantity * product.price | priceFromCentEuro }}</td>
    <td class="text-right">
      <span v-if="! editMode">{{ product.warnschwelle }}</span>
      <input v-else class="form-control quick-input" v-model="productToEdit.warnschwelle">
    </td>
    <td class="text-right">
      <span v-if="! editMode">{{ product.lager_soll_menge }}</span>
      <input v-else class="form-control quick-input" v-model="productToEdit.lager_soll_menge">
    </td>
    <td class="text-right">{{ product.quantity_sold || 0 }}</td>
    <td class="nowrap">{{ product.latest_in || '' | datetime }}</td>
    <td class="nowrap">{{ product.latest_out || '' | datetime }}</td>
    <td class="text-center" v-if="showWarehouses">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td class="text-right">
      <div class="td-actions">
        <template v-if="!onlyShowAction && !editMode">
          <button class="btn btn-warning btn-link btn-xs"
            v-tooltip.top-center="'Bearbeiten'"
            @click="enterEditMode"
          >
            <i class="fas fa-edit"></i>
          </button>
          <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
            @click="$emit('deleteProduct', product)"
          >
            <i class="fa fa-close"></i>
          </a>
        </template>
        <template v-if="editMode">
          <div class="edit-mode-actions">
            <button class="btn btn-success btn-link btn-xs"
              v-tooltip.top-center="'Speichern'"
              @click="saveEdit"
            >
              <i class="fas fa-check"></i>
            </button>
            <button class="btn btn-danger btn-link btn-xs"
              v-tooltip.top-center="'Cancel'"
              @click="exitEditMode"
            >
              <i class="fa fa-close"></i>
            </button>
          </div>
        </template>
      </div>
    </td>
  </tr>
</template>

<script>
import api from 'src/api'
import { groupNewestSuppliers } from 'src/util/helpers'
import priceWatcher from 'src/pages/Products/price-watcher'
import cloneDeep from 'lodash/cloneDeep'
import PriceInput from 'src/components/price-input'
import { Popover, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'

export default {
  props: ['product', 'onlyShowAction', 'showWarehouses', 'editMode', 'productCategories', 'units'],
  mixins: [priceWatcher],
  components: {
    PriceInput,
    [Popover.name]: Popover,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data () {
    return {
      api,
      productToEdit: null
    }
  },
  methods: {
    enterEditMode () {
      this.productToEdit = cloneDeep(this.product)
      this.$emit('enterEditMode', this.product)
    },
    exitEditMode () {
      this.productToEdit = null
      this.$emit('exitEditMode', this.product)
    },
    saveEdit () {
      this.$emit('saveEdit', this.productToEdit)
    },
    getPrice () {
      return this.productToEdit.price
    },
    setPrice (price) {
      this.productToEdit.price = price
    },
    openAssignToSuppliersDialog () {
      this.$emit('openAssignToSuppliersDialog', this.product)
    },
    openStockRotationModal (direction) {
      this.$emit('openStockRotationModal', {
        direction,
        product: this.product
      })
    },
    addInstances () {
      this.$emit('openAddInstanceDialog', this.product)
    }
  },
  computed: {
    productSuppliers () {
      return groupNewestSuppliers(this.product.suppliers)
    },
    cheapestSupplier () {
      return this.productSuppliers.length ? this.productSuppliers[0] : false
    },
    cheapestPrice () {
      return this.product.einkaufspreis
    }
  }
}
</script>

<style scoped>
  .edit-mode-actions .btn {
    opacity: 1 !important;
  }
  .quick-input {
    min-width: 60px;
  }
  .td-actions {
    min-width: 50px;
  }
</style>
